/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TreePlotter v3 API
 * TreePlotter v3 API
 * OpenAPI spec version: 4.51.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  BadRequestResponse,
  CompleteWorkTask,
  CreateWorkTask,
  CreateWorkTask201,
  FilterWorkTaskIdsParams,
  FindWorkTasksBody,
  FindWorkTasksParams,
  ForbiddenErrorResponse,
  GetWorkTaskFilterOptionsParams,
  GetWorkTaskTypesParams,
  Id,
  LinkPhotosToWorkTask,
  PutWorkTasksFromTP2,
  PutWorkTasksFromTP2200,
  RestartWorkTask,
  SetWorkTaskTp2WorkRecordId,
  UnauthorizedErrorResponse,
  UnlinkPhotosFromWorkTask,
  WorkTask,
  WorkTaskFilterCriteria,
  WorkTaskFilterIdsResult,
  WorkTaskFilterOptions,
  WorkTaskTypeCatalog,
} from ".././model";

import { httpClient } from "../../../src/common/infrastructure/api/http-client";

/**
 * Pull work tasks from TP2 and create them in TP3
 * @summary Sync work tasks from TP2
 */
export const putWorkTasksFromTP2 = (
  putWorkTasksFromTP2: PutWorkTasksFromTP2,
  signal?: AbortSignal
) => {
  return httpClient<PutWorkTasksFromTP2200 | void>({
    url: `/command-service/tenant/service/tp2-interop/put-work-tasks-from-tp2`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: putWorkTasksFromTP2,
    signal,
  });
};

export const getPutWorkTasksFromTP2MutationOptions = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putWorkTasksFromTP2>>,
    TError,
    { data: PutWorkTasksFromTP2 },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putWorkTasksFromTP2>>,
  TError,
  { data: PutWorkTasksFromTP2 },
  TContext
> => {
  const mutationKey = ["putWorkTasksFromTP2"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putWorkTasksFromTP2>>,
    { data: PutWorkTasksFromTP2 }
  > = (props) => {
    const { data } = props ?? {};

    return putWorkTasksFromTP2(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutWorkTasksFromTP2MutationResult = NonNullable<
  Awaited<ReturnType<typeof putWorkTasksFromTP2>>
>;
export type PutWorkTasksFromTP2MutationBody = PutWorkTasksFromTP2;
export type PutWorkTasksFromTP2MutationError = void | UnauthorizedErrorResponse;

/**
 * @summary Sync work tasks from TP2
 */
export const usePutWorkTasksFromTP2 = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putWorkTasksFromTP2>>,
      TError,
      { data: PutWorkTasksFromTP2 },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putWorkTasksFromTP2>>,
  TError,
  { data: PutWorkTasksFromTP2 },
  TContext
> => {
  const mutationOptions = getPutWorkTasksFromTP2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Unified endpoint for fetching work tasks. Supports three modes:
1. No body: Fetch all work tasks for tenant
2. Body with filters: Fetch work tasks matching filter criteria
3. Body with workTasks: Fetch specific work tasks by ID with HLC staleness detection

 * @summary Find work tasks
 */
export const findWorkTasks = (
  findWorkTasksBody?: FindWorkTasksBody,
  params?: FindWorkTasksParams,
  signal?: AbortSignal
) => {
  return httpClient<WorkTask[]>({
    url: `/work-management/api/work-tasks`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: findWorkTasksBody,
    params,
    signal,
  });
};

export const getFindWorkTasksMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof findWorkTasks>>,
    TError,
    { data: FindWorkTasksBody; params?: FindWorkTasksParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof findWorkTasks>>,
  TError,
  { data: FindWorkTasksBody; params?: FindWorkTasksParams },
  TContext
> => {
  const mutationKey = ["findWorkTasks"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof findWorkTasks>>,
    { data: FindWorkTasksBody; params?: FindWorkTasksParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return findWorkTasks(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type FindWorkTasksMutationResult = NonNullable<
  Awaited<ReturnType<typeof findWorkTasks>>
>;
export type FindWorkTasksMutationBody = FindWorkTasksBody;
export type FindWorkTasksMutationError =
  | BadRequestResponse
  | UnauthorizedErrorResponse
  | ForbiddenErrorResponse;

/**
 * @summary Find work tasks
 */
export const useFindWorkTasks = <
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof findWorkTasks>>,
      TError,
      { data: FindWorkTasksBody; params?: FindWorkTasksParams },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof findWorkTasks>>,
  TError,
  { data: FindWorkTasksBody; params?: FindWorkTasksParams },
  TContext
> => {
  const mutationOptions = getFindWorkTasksMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get filter options for work tasks for a tenant. Returns the requested filter types.
 * @summary Get work task filter options
 */
export const getWorkTaskFilterOptions = (
  params: GetWorkTaskFilterOptionsParams,
  signal?: AbortSignal
) => {
  return httpClient<WorkTaskFilterOptions>({
    url: `/work-management/api/work-tasks/filter-options`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetWorkTaskFilterOptionsQueryKey = (
  params?: GetWorkTaskFilterOptionsParams
) => {
  return [
    "work-management",
    "api",
    "work-tasks",
    "filter-options",
    ...(params ? [params] : []),
  ] as const;
};

export const getGetWorkTaskFilterOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getWorkTaskFilterOptions>>,
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse
>(
  params: GetWorkTaskFilterOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkTaskFilterOptions>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetWorkTaskFilterOptionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWorkTaskFilterOptions>>
  > = ({ signal }) => getWorkTaskFilterOptions(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWorkTaskFilterOptions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetWorkTaskFilterOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWorkTaskFilterOptions>>
>;
export type GetWorkTaskFilterOptionsQueryError =
  | BadRequestResponse
  | UnauthorizedErrorResponse
  | ForbiddenErrorResponse;

export function useGetWorkTaskFilterOptions<
  TData = Awaited<ReturnType<typeof getWorkTaskFilterOptions>>,
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse
>(
  params: GetWorkTaskFilterOptionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkTaskFilterOptions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkTaskFilterOptions>>,
          TError,
          Awaited<ReturnType<typeof getWorkTaskFilterOptions>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWorkTaskFilterOptions<
  TData = Awaited<ReturnType<typeof getWorkTaskFilterOptions>>,
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse
>(
  params: GetWorkTaskFilterOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkTaskFilterOptions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkTaskFilterOptions>>,
          TError,
          Awaited<ReturnType<typeof getWorkTaskFilterOptions>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWorkTaskFilterOptions<
  TData = Awaited<ReturnType<typeof getWorkTaskFilterOptions>>,
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse
>(
  params: GetWorkTaskFilterOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkTaskFilterOptions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get work task filter options
 */

export function useGetWorkTaskFilterOptions<
  TData = Awaited<ReturnType<typeof getWorkTaskFilterOptions>>,
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse
>(
  params: GetWorkTaskFilterOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkTaskFilterOptions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetWorkTaskFilterOptionsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get the catalog of work task types (work activities joined with their categories) for a tenant. Used to populate the task-type options when creating work. taskTypeCategoryLabel is null for uncategorized activities.
 * @summary Get work task type catalog
 */
export const getWorkTaskTypes = (
  params: GetWorkTaskTypesParams,
  signal?: AbortSignal
) => {
  return httpClient<WorkTaskTypeCatalog>({
    url: `/work-management/api/work-tasks/task-types`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetWorkTaskTypesQueryKey = (
  params?: GetWorkTaskTypesParams
) => {
  return [
    "work-management",
    "api",
    "work-tasks",
    "task-types",
    ...(params ? [params] : []),
  ] as const;
};

export const getGetWorkTaskTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof getWorkTaskTypes>>,
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse
>(
  params: GetWorkTaskTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkTaskTypes>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetWorkTaskTypesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWorkTaskTypes>>
  > = ({ signal }) => getWorkTaskTypes(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWorkTaskTypes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetWorkTaskTypesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWorkTaskTypes>>
>;
export type GetWorkTaskTypesQueryError =
  | BadRequestResponse
  | UnauthorizedErrorResponse
  | ForbiddenErrorResponse;

export function useGetWorkTaskTypes<
  TData = Awaited<ReturnType<typeof getWorkTaskTypes>>,
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse
>(
  params: GetWorkTaskTypesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkTaskTypes>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkTaskTypes>>,
          TError,
          Awaited<ReturnType<typeof getWorkTaskTypes>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWorkTaskTypes<
  TData = Awaited<ReturnType<typeof getWorkTaskTypes>>,
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse
>(
  params: GetWorkTaskTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkTaskTypes>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkTaskTypes>>,
          TError,
          Awaited<ReturnType<typeof getWorkTaskTypes>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWorkTaskTypes<
  TData = Awaited<ReturnType<typeof getWorkTaskTypes>>,
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse
>(
  params: GetWorkTaskTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkTaskTypes>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get work task type catalog
 */

export function useGetWorkTaskTypes<
  TData = Awaited<ReturnType<typeof getWorkTaskTypes>>,
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse
>(
  params: GetWorkTaskTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkTaskTypes>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetWorkTaskTypesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Filter work task IDs based on criteria. Returns only IDs, allowing for higher pagination limits.
 * @summary Filter work task IDs
 */
export const filterWorkTaskIds = (
  workTaskFilterCriteria: WorkTaskFilterCriteria,
  params: FilterWorkTaskIdsParams,
  signal?: AbortSignal
) => {
  return httpClient<WorkTaskFilterIdsResult>({
    url: `/work-management/api/work-tasks/filter-ids`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: workTaskFilterCriteria,
    params,
    signal,
  });
};

export const getFilterWorkTaskIdsMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof filterWorkTaskIds>>,
    TError,
    { data: WorkTaskFilterCriteria; params: FilterWorkTaskIdsParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof filterWorkTaskIds>>,
  TError,
  { data: WorkTaskFilterCriteria; params: FilterWorkTaskIdsParams },
  TContext
> => {
  const mutationKey = ["filterWorkTaskIds"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof filterWorkTaskIds>>,
    { data: WorkTaskFilterCriteria; params: FilterWorkTaskIdsParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return filterWorkTaskIds(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type FilterWorkTaskIdsMutationResult = NonNullable<
  Awaited<ReturnType<typeof filterWorkTaskIds>>
>;
export type FilterWorkTaskIdsMutationBody = WorkTaskFilterCriteria;
export type FilterWorkTaskIdsMutationError =
  | BadRequestResponse
  | UnauthorizedErrorResponse
  | ForbiddenErrorResponse;

/**
 * @summary Filter work task IDs
 */
export const useFilterWorkTaskIds = <
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof filterWorkTaskIds>>,
      TError,
      { data: WorkTaskFilterCriteria; params: FilterWorkTaskIdsParams },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof filterWorkTaskIds>>,
  TError,
  { data: WorkTaskFilterCriteria; params: FilterWorkTaskIdsParams },
  TContext
> => {
  const mutationOptions = getFilterWorkTaskIdsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Create a new work task
 * @summary Create work task
 */
export const createWorkTask = (
  tenantId: Id,
  workTaskId: Id,
  createWorkTask: CreateWorkTask,
  signal?: AbortSignal
) => {
  return httpClient<CreateWorkTask201 | void>({
    url: `/command-service/tenant/${tenantId}/work/aggregate/work-task/${workTaskId}/create-work-task`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createWorkTask,
    signal,
  });
};

export const getCreateWorkTaskMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWorkTask>>,
    TError,
    { tenantId: Id; workTaskId: Id; data: CreateWorkTask },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createWorkTask>>,
  TError,
  { tenantId: Id; workTaskId: Id; data: CreateWorkTask },
  TContext
> => {
  const mutationKey = ["createWorkTask"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createWorkTask>>,
    { tenantId: Id; workTaskId: Id; data: CreateWorkTask }
  > = (props) => {
    const { tenantId, workTaskId, data } = props ?? {};

    return createWorkTask(tenantId, workTaskId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateWorkTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof createWorkTask>>
>;
export type CreateWorkTaskMutationBody = CreateWorkTask;
export type CreateWorkTaskMutationError =
  | BadRequestResponse
  | UnauthorizedErrorResponse
  | ForbiddenErrorResponse;

/**
 * @summary Create work task
 */
export const useCreateWorkTask = <
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createWorkTask>>,
      TError,
      { tenantId: Id; workTaskId: Id; data: CreateWorkTask },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createWorkTask>>,
  TError,
  { tenantId: Id; workTaskId: Id; data: CreateWorkTask },
  TContext
> => {
  const mutationOptions = getCreateWorkTaskMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Complete an existing work task
 * @summary Complete work task
 */
export const completeWorkTask = (
  tenantId: Id,
  workTaskId: Id,
  completeWorkTask: CompleteWorkTask,
  signal?: AbortSignal
) => {
  return httpClient<void | void>({
    url: `/command-service/tenant/${tenantId}/work/aggregate/work-task/${workTaskId}/complete-work-task`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: completeWorkTask,
    signal,
  });
};

export const getCompleteWorkTaskMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse
    | void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeWorkTask>>,
    TError,
    { tenantId: Id; workTaskId: Id; data: CompleteWorkTask },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completeWorkTask>>,
  TError,
  { tenantId: Id; workTaskId: Id; data: CompleteWorkTask },
  TContext
> => {
  const mutationKey = ["completeWorkTask"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeWorkTask>>,
    { tenantId: Id; workTaskId: Id; data: CompleteWorkTask }
  > = (props) => {
    const { tenantId, workTaskId, data } = props ?? {};

    return completeWorkTask(tenantId, workTaskId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompleteWorkTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof completeWorkTask>>
>;
export type CompleteWorkTaskMutationBody = CompleteWorkTask;
export type CompleteWorkTaskMutationError =
  | BadRequestResponse
  | UnauthorizedErrorResponse
  | ForbiddenErrorResponse
  | void;

/**
 * @summary Complete work task
 */
export const useCompleteWorkTask = <
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse
    | void,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof completeWorkTask>>,
      TError,
      { tenantId: Id; workTaskId: Id; data: CompleteWorkTask },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof completeWorkTask>>,
  TError,
  { tenantId: Id; workTaskId: Id; data: CompleteWorkTask },
  TContext
> => {
  const mutationOptions = getCompleteWorkTaskMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Restart a work task
 * @summary Restart work task
 */
export const restartWorkTask = (
  tenantId: Id,
  workTaskId: Id,
  restartWorkTask: RestartWorkTask,
  signal?: AbortSignal
) => {
  return httpClient<void | void>({
    url: `/command-service/tenant/${tenantId}/work/aggregate/work-task/${workTaskId}/restart-work-task`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: restartWorkTask,
    signal,
  });
};

export const getRestartWorkTaskMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse
    | void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restartWorkTask>>,
    TError,
    { tenantId: Id; workTaskId: Id; data: RestartWorkTask },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restartWorkTask>>,
  TError,
  { tenantId: Id; workTaskId: Id; data: RestartWorkTask },
  TContext
> => {
  const mutationKey = ["restartWorkTask"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restartWorkTask>>,
    { tenantId: Id; workTaskId: Id; data: RestartWorkTask }
  > = (props) => {
    const { tenantId, workTaskId, data } = props ?? {};

    return restartWorkTask(tenantId, workTaskId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestartWorkTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof restartWorkTask>>
>;
export type RestartWorkTaskMutationBody = RestartWorkTask;
export type RestartWorkTaskMutationError =
  | BadRequestResponse
  | UnauthorizedErrorResponse
  | ForbiddenErrorResponse
  | void;

/**
 * @summary Restart work task
 */
export const useRestartWorkTask = <
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse
    | void,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof restartWorkTask>>,
      TError,
      { tenantId: Id; workTaskId: Id; data: RestartWorkTask },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof restartWorkTask>>,
  TError,
  { tenantId: Id; workTaskId: Id; data: RestartWorkTask },
  TContext
> => {
  const mutationOptions = getRestartWorkTaskMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Set the TP2 work record id on the work task aggregate.
 * @summary Set work task TP2 work record id
 */
export const setWorkTaskTp2WorkRecordId = (
  tenantId: Id,
  workTaskId: Id,
  setWorkTaskTp2WorkRecordId: SetWorkTaskTp2WorkRecordId,
  signal?: AbortSignal
) => {
  return httpClient<void | void>({
    url: `/command-service/tenant/${tenantId}/work/aggregate/work-task/${workTaskId}/set-tp2-work-record-id`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: setWorkTaskTp2WorkRecordId,
    signal,
  });
};

export const getSetWorkTaskTp2WorkRecordIdMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse
    | void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setWorkTaskTp2WorkRecordId>>,
    TError,
    { tenantId: Id; workTaskId: Id; data: SetWorkTaskTp2WorkRecordId },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setWorkTaskTp2WorkRecordId>>,
  TError,
  { tenantId: Id; workTaskId: Id; data: SetWorkTaskTp2WorkRecordId },
  TContext
> => {
  const mutationKey = ["setWorkTaskTp2WorkRecordId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setWorkTaskTp2WorkRecordId>>,
    { tenantId: Id; workTaskId: Id; data: SetWorkTaskTp2WorkRecordId }
  > = (props) => {
    const { tenantId, workTaskId, data } = props ?? {};

    return setWorkTaskTp2WorkRecordId(tenantId, workTaskId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetWorkTaskTp2WorkRecordIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof setWorkTaskTp2WorkRecordId>>
>;
export type SetWorkTaskTp2WorkRecordIdMutationBody = SetWorkTaskTp2WorkRecordId;
export type SetWorkTaskTp2WorkRecordIdMutationError =
  | BadRequestResponse
  | UnauthorizedErrorResponse
  | ForbiddenErrorResponse
  | void;

/**
 * @summary Set work task TP2 work record id
 */
export const useSetWorkTaskTp2WorkRecordId = <
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse
    | void,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setWorkTaskTp2WorkRecordId>>,
      TError,
      { tenantId: Id; workTaskId: Id; data: SetWorkTaskTp2WorkRecordId },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof setWorkTaskTp2WorkRecordId>>,
  TError,
  { tenantId: Id; workTaskId: Id; data: SetWorkTaskTp2WorkRecordId },
  TContext
> => {
  const mutationOptions = getSetWorkTaskTp2WorkRecordIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Link existing photos to a work task
 * @summary Link photos to work task
 */
export const linkPhotosToWorkTask = (
  tenantId: Id,
  workTaskId: Id,
  linkPhotosToWorkTask: LinkPhotosToWorkTask,
  signal?: AbortSignal
) => {
  return httpClient<void | void>({
    url: `/command-service/tenant/${tenantId}/work/aggregate/work-task/${workTaskId}/link-photos-to-work-task`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: linkPhotosToWorkTask,
    signal,
  });
};

export const getLinkPhotosToWorkTaskMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse
    | void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof linkPhotosToWorkTask>>,
    TError,
    { tenantId: Id; workTaskId: Id; data: LinkPhotosToWorkTask },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof linkPhotosToWorkTask>>,
  TError,
  { tenantId: Id; workTaskId: Id; data: LinkPhotosToWorkTask },
  TContext
> => {
  const mutationKey = ["linkPhotosToWorkTask"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof linkPhotosToWorkTask>>,
    { tenantId: Id; workTaskId: Id; data: LinkPhotosToWorkTask }
  > = (props) => {
    const { tenantId, workTaskId, data } = props ?? {};

    return linkPhotosToWorkTask(tenantId, workTaskId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LinkPhotosToWorkTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof linkPhotosToWorkTask>>
>;
export type LinkPhotosToWorkTaskMutationBody = LinkPhotosToWorkTask;
export type LinkPhotosToWorkTaskMutationError =
  | BadRequestResponse
  | UnauthorizedErrorResponse
  | ForbiddenErrorResponse
  | void;

/**
 * @summary Link photos to work task
 */
export const useLinkPhotosToWorkTask = <
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse
    | void,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof linkPhotosToWorkTask>>,
      TError,
      { tenantId: Id; workTaskId: Id; data: LinkPhotosToWorkTask },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof linkPhotosToWorkTask>>,
  TError,
  { tenantId: Id; workTaskId: Id; data: LinkPhotosToWorkTask },
  TContext
> => {
  const mutationOptions = getLinkPhotosToWorkTaskMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Unlink photos from a work task
 * @summary Unlink photos from work task
 */
export const unlinkPhotosFromWorkTask = (
  tenantId: Id,
  workTaskId: Id,
  unlinkPhotosFromWorkTask: UnlinkPhotosFromWorkTask,
  signal?: AbortSignal
) => {
  return httpClient<void | void>({
    url: `/command-service/tenant/${tenantId}/work/aggregate/work-task/${workTaskId}/unlink-photos-from-work-task`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: unlinkPhotosFromWorkTask,
    signal,
  });
};

export const getUnlinkPhotosFromWorkTaskMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse
    | void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlinkPhotosFromWorkTask>>,
    TError,
    { tenantId: Id; workTaskId: Id; data: UnlinkPhotosFromWorkTask },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlinkPhotosFromWorkTask>>,
  TError,
  { tenantId: Id; workTaskId: Id; data: UnlinkPhotosFromWorkTask },
  TContext
> => {
  const mutationKey = ["unlinkPhotosFromWorkTask"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlinkPhotosFromWorkTask>>,
    { tenantId: Id; workTaskId: Id; data: UnlinkPhotosFromWorkTask }
  > = (props) => {
    const { tenantId, workTaskId, data } = props ?? {};

    return unlinkPhotosFromWorkTask(tenantId, workTaskId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlinkPhotosFromWorkTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlinkPhotosFromWorkTask>>
>;
export type UnlinkPhotosFromWorkTaskMutationBody = UnlinkPhotosFromWorkTask;
export type UnlinkPhotosFromWorkTaskMutationError =
  | BadRequestResponse
  | UnauthorizedErrorResponse
  | ForbiddenErrorResponse
  | void;

/**
 * @summary Unlink photos from work task
 */
export const useUnlinkPhotosFromWorkTask = <
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse
    | void,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof unlinkPhotosFromWorkTask>>,
      TError,
      { tenantId: Id; workTaskId: Id; data: UnlinkPhotosFromWorkTask },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof unlinkPhotosFromWorkTask>>,
  TError,
  { tenantId: Id; workTaskId: Id; data: UnlinkPhotosFromWorkTask },
  TContext
> => {
  const mutationOptions = getUnlinkPhotosFromWorkTaskMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
